/* @flow */
import * as React from 'react';

const ClosingTimes = props => (
  <svg
    width={56}
    height={56}
    viewBox="0 0 56 56"
    stroke="none"
    strokeWidth={1}
    fillRule="evenodd"
    {...props}>
    <circle fill="#677BC5" cx={28} cy={28} r={28} />
    <path
      fill="#FFFFFF"
      d="M28.275,39.573 C21.648,39.573 16.275,34.201 16.275,27.573 C16.275,20.946 21.648,15.573 28.275,15.573 C34.903,15.573 40.275,20.946 40.275,27.573 C40.275,34.201 34.903,39.573 28.275,39.573 Z M27,21.502 L27,27 L30,27 L30,21.502 C30,20.671 29.328,20 28.5,20 C27.666,20 27,20.672 27,21.502 Z M23,28.5 C23,29.334 23.672,30 24.502,30 L28.498,30 C29.329,30 30,29.328 30,28.5 L30,27 L24.502,27 C23.671,27 23,27.672 23,28.5 Z"
    />
  </svg>
);

export default ClosingTimes;



// WEBPACK FOOTER //
// ./src/assets/images/icons/closing-times.js